import Navbar from '../Navbar'
import Footer from '../Footer'
import Maintenance from '../Maintenance';
import { useEffect, useState } from 'react';
import Loader from '../Loader';
import { fetchUserToken } from '../../helper/api-methods';
import appboy from 'appboy-web-sdk';
import Header from '../Header';
function PublicLayout(props){
    const [ loading, setLoading ] = useState(true);
    
    useEffect(()=>{
        const guestToken = localStorage.getItem("guestToken");
        if(guestToken && guestToken.length){
            setLoading(false);
        }
        else{
            fetchUserToken("web/guestUserLogin").then((response) => {
                if(response.data.Status){
                    localStorage.setItem("guestToken",response.data.Data?.Token?.Access_Token);
                    localStorage.setItem("guestCustomerGuid",response.data.Data?.UserInfo?.CustomerGuid);
                    appboy.changeUser(response.data.Data.UserInfo?.CustomerGuid);
                    setTimeout(() => { setLoading(false); }, 500);
                }
                else {
                    setTimeout(() => { setLoading(false); }, 500);
                }
                
            })
        }
        setLoading(false);
    },[])

    return (
        props.maintenance ? <Maintenance/> :
        loading ? <Loader/> :
        <>
            { props.hasHeader ? <Header/> : <></> }
            <div className={props.hasHeader ? "" : "no-breadcrumb"}>
                {props.children}
            </div>
            { props.hasFooter ? <Footer/> : <></> }
            {/* <a href='https://wa.me/9668002440339' className='whatsapp-button' target='_blank'><i className="ri-whatsapp-line"></i></a> */}
        </>
    )
}
export default PublicLayout; 